var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgASalariosBackground(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 448,
    height: 222,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M405.621 145.153c5.428-5.979 11.379-14.641 11.379-32.429 0-17.79-8.005-25.796-8.005-25.796l-2.662-3.085-65.57-75.063a25.524 25.524 0 00-7.899-6.121 25.31 25.31 0 00-19.499-1.292 25.449 25.449 0 00-8.625 5.026l-.252.233a25.661 25.661 0 00-6.05 7.97 25.875 25.875 0 00-1.236 19.647 25.736 25.736 0 005.002 8.678l48.659 55.796a20.583 20.583 0 015.365 13.732 19.021 19.021 0 01-1.592 7.733 18.884 18.884 0 01-4.59 6.401l-56.685 52.457a25.886 25.886 0 00-6.31 18.635 25.83 25.83 0 008.594 17.682l.272.232a25.394 25.394 0 0018.474 6.359 25.443 25.443 0 0017.528-8.662l73.702-68.133z",
    fill: "#3DE5DF"
  })));
}
export default __webpack_public_path__ + "static/media/a-salarios-background.8cc82377.svg";
export { SvgASalariosBackground as ReactComponent };